<template>
    <div ref="container" class="container">

        <header class='text-center'>
            <div class="header-icon header-icon--login"></div>
            <!-- <img src="/img/egl/lock-standard3.svg" alt="" class="header-icon"> -->
            <h1 class="h2">{{ $t('translations.do_you_have_an_askmyGP_login', {'article_app_name': tBrand("article_app_name")})}}?</h1>
            <p v-if="tBrand('online_service_login_message', false, false)">{{ tBrand('online_service_login_message') }}.</p>
            <p v-if="this.$root.provider.name">{{ autobrand("translations.patients_must_be_registered_at_provider", {provider: getProvider()}) }}</p>
        </header>

        <div>
            <div class="list-message_item">
                <div class="message-neutral">
                    <router-link :to="{name: 'Register', params: {next: 'Profile'}}" tag="button" class="btn btn-round btn-block btn-primary">{{ $t('translations.sign_up_as_a_new_user')}}</router-link>
                    <router-link :to="{name: 'loginForm', params: {next: 'Profile'}}" tag="button" class="btn btn-round btn-block btn-primary">{{ $t('translations.login_existing_user')}}</router-link>
                </div>
            </div>

        </div>
    </div><!--ref:container-->


</template>

<script>
var moment = require('moment');
export default {
    props: [
    ],
    data: function(){
        return {

        }
    },
    mounted() {

    },
    methods: {
        getProvider() {
            if(this.$root.provider) {
                return this.$root.provider.name;
            }
            return "";
        },
    }
}
</script>
